import { LitElement, html, nothing } from 'lit';
import { sheet } from '../styles.js';

export class Switch extends LitElement {
	static formAssociated = true;
	static styles = [sheet];

	static get properties() {
		return {
			onValue: { type: String, attribute: 'on-value' },
			offValue: { type: String, attribute: 'off-value' },
			onLabel: { type: String, attribute: 'on-label' },
			offLabel: { type: String, attribute: 'off-label' },
			label: { type: String, reflect: true },
			checked: { type: Boolean, reflect: true },
			disabled: { type: Boolean, reflect: true }
		}
	}

	#initialChecked = false;
	#initialDisabled = false;

	constructor() {
		super();
		this.internals = this.attachInternals();
		this.onValue = true;
		this.offValue = false;
		this.onLabel = '';
		this.offLabel = '';
		this.label = '';
		this.checked = false;
		this.disabled = false;
	}

	connectedCallback() {
		super.connectedCallback();
		this.#initialChecked = this.hasAttribute('checked');
		this.#initialDisabled = this.hasAttribute('disabled');
		this.value = this.checked ? this.onValue : this.offValue;
		this.internals.setFormValue(this.value);
	}

	async formResetCallback() {
		this.checked = this.#initialChecked;
		this.disabled = this.#initialDisabled;
		await this.updateComplete;
		const input = this.renderRoot.querySelector('input');
		input.checked = this.checked;
		input.dispatchEvent(new Event('change'));
	}

	render() {
		return html`
			${this.label ? html`<small class="fw-light fg-4">${this.label}</small>` : ''}
			<div class="d-flex align-items-center gap-3">
				${this.offLabel ? html`<label>${this.offLabel}</label>` : ''}
				<div class="switch">
					<input
						type="checkbox"
						name=${this.getAttribute('name') || nothing}
						.checked=${this.checked}
						?disabled=${this.disabled}
						@change=${this.#onChange}
					>
				</div>
				${this.onLabel ? html`<label>${this.onLabel}</label>` : ''}
			</div>
		`;
	}

	#onChange(event) {
		this.checked = event.target.checked;
		this.value = this.checked ? this.onValue : this.offValue;
		this.internals.setFormValue(this.value);
		this.dispatchEvent(new CustomEvent('switch-changed', { detail: event, bubbles: true, composed: true }));
	}
}

customElements.define('u-switch', Switch);
